
module.directive('createEducationTestForm', function(ModelService) {
    return {
        restrict: 'E',
        templateUrl: 'students/educationProfile/educationTestForm',
        scope: {testType: '@', profile: '='},
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            scope.data = basicForm.data = {};
            scope.form = basicForm.getForm();

            basicForm.save = function(data) {
                data = angular.copy(data);
                data['test_type'] = scope.testType;
                return ModelService.postModelRelation(scope.profile, 'tests', data);
            };
        },
    };
});
